export default {
  'server.ping': 1,
  'today.subscribe': 2,
  'kline.unsubscribe': 3,
  'kline.subscribe': 4,
  'kline.query': 5,
  'today.unsubscribe': 6,
  'deals.query': 7,
}